module.exports = __webpack_public_path__ + "images/psp/PSPHero/portable-hero.webp";